import React from "react";
import history from "Services/history";
import ClientLogo from "Assets/img/QLD_CoA_Website_LOGO.svg";
import logo from "Assets/img/geografia_logo.svg";
import Glossary from "Views/About/glossary.md";
import HowToUse from "Views/About/How-to-use-this-site.md";
import AboutGeography from "Views/About/About-the-geography.md";
import AboutData from "Views/About/About-the-data.md";
import Disclaimer from "Views/About/Disclaimer.md";
import APIAccess from "Views/About/API-access.md";
import template_render from "Utils/template_render";
import config from "Config";

import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col
} from "reactstrap";
import classnames from "classnames";
import withState from "recompose/withState";

const SpecialLayout = ({ children }) =>
  (({ height = 150 }) => (
    <div className="col-1 d-flex flex-column">
      <div style={{ height }} className="row dark-header-clr">
        <div className="col" />
      </div>
      <div style={{ flex: 1 }} className="row grey">
        <div className="col" />
      </div>
    </div>
  )).chain(SideColumn => (
    <div style={{ flex: 1 }} className="row mt-4 align-items-stretch">
      <SideColumn />
      <div className="col-10 white">
        <div className="p-3">{children}</div>
      </div>
      <SideColumn />
    </div>
  ));

const addTabState = withState("activeTab", "setActiveTab", "2");

const Tabs = addTabState(({ activeTab, setActiveTab }) => (
  <div>
    <Nav tabs>
      <NavItem>
        <NavLink
          className={classnames({ active: activeTab === "2" })}
          onClick={() => {
            setActiveTab("2");
          }}
        >
          How to use this site
        </NavLink>
      </NavItem>

      <NavItem>
        <NavLink
          className={classnames({ active: activeTab === "3" })}
          onClick={() => {
            setActiveTab("3");
          }}
        >
          About the geography
        </NavLink>
      </NavItem>

      <NavItem>
        <NavLink
          className={classnames({ active: activeTab === "4" })}
          onClick={() => {
            setActiveTab("4");
          }}
        >
          About the data
        </NavLink>
      </NavItem>

      <NavItem>
        <NavLink
          className={classnames({ active: activeTab === "api-access" })}
          onClick={() => {
            setActiveTab("api-access");
          }}
        >
          API access
        </NavLink>
      </NavItem>

      <NavItem>
        <NavLink
          className={classnames({ active: activeTab === "glossary" })}
          onClick={() => {
            setActiveTab("glossary");
          }}
        >
          Glossary
        </NavLink>
      </NavItem>
    </Nav>
    <TabContent activeTab={activeTab}>
      <TabPane tabId="2">
        <Row>
          <Col sm="12">
            <div
              dangerouslySetInnerHTML={{
                __html: template_render(HowToUse, config)
              }}
            ></div>
          </Col>
        </Row>
      </TabPane>

      <TabPane tabId="3">
        <Row>
          <Col sm="12">
            <div
              dangerouslySetInnerHTML={{
                __html: template_render(AboutGeography, config)
              }}
            ></div>
          </Col>
        </Row>
      </TabPane>

      <TabPane tabId="4">
        <Row>
          <Col sm="12">
            <div
              dangerouslySetInnerHTML={{
                __html: template_render(AboutData, config)
              }}
            ></div>
          </Col>
        </Row>
      </TabPane>

      <TabPane tabId="api-access">
        <Row>
          <Col sm="12">
            <div
              dangerouslySetInnerHTML={{
                __html: template_render(APIAccess, config)
              }}
            ></div>
          </Col>
        </Row>
      </TabPane>

      <TabPane tabId="glossary">
        <Row>
          <Col sm="12">
            <div
              id="glossary-list"
              dangerouslySetInnerHTML={{
                __html: template_render(Glossary, config)
              }}
            ></div>
          </Col>
        </Row>
      </TabPane>
    </TabContent>
  </div>
));

const TopMenu = () => (
  <div
    id="topmenu"
    className="top-menu-bg-det black align-items-center justify-content-between"
  >
    {/* <div className="app_logo">
      <strong>DLGRMA</strong>
    </div> */}
    <div className="mr-auto client_logo">
      <a
        className=""
        href={config.department_url}
        target="_blank"
        rel="noopener"
      >
        <img src={ClientLogo} />
      </a>
    </div>
    <div className="company_logo ml-auto company_logo">
      <a
        className="ml-auto"
        target="_blank"
        rel="noopener"
        href="http://geografia.com.au"
      >
        <img src={logo} />
      </a>
    </div>
  </div>
);

const Template = () => (
  <div id="details-view" className="dark-header-clr">
    <TopMenu tree="" />
    <div className="pt-4 row">
      <div onClick={_ => history.goBack()} className="col-1">
        <i className="fa fa-arrow-left fa-2x" />
      </div>
      <div className="col-10">
        <div className="row">
          <div id="details-title" className="col-8">
            Explanatory Notes
          </div>
        </div>
      </div>
    </div>
    <SpecialLayout>
      <Tabs />
      <hr />
      <div dangerouslySetInnerHTML={{ __html: Disclaimer }}></div>
    </SpecialLayout>
  </div>
);

export default Template;



// WEBPACK FOOTER //
// ./views/AboutPage.js